import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal.js';
import {
  CANCEL_TEXT,
  STAFF_AUGMENTATION,
} from '../../Constants/strings.js';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';

const DeleteStaffAugmentationDialog = ({
  handleCloseAction,
  handleDeleteAction,
  setIsDialogOpen,
  setIsEdit,
  isOpen,
}) => {
  const content = STAFF_AUGMENTATION;

  return (
    <FormDialog
      open={isOpen}
      title={content.DELETE_STAFF_REQUIREMENT_TITLE_TEXT}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="delete-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">
            {content.DELETE_STAFF_REQUIREMENT_MESSAGE}
          </div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.DELETE_STAFF_AUG_STATUS_BUTTON_ID}
      button2={content.DELETE.BUTTON_TEXT}
      button2Action={handleDeleteAction}
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
    />
  );
};

DeleteStaffAugmentationDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default DeleteStaffAugmentationDialog;
